import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';

// * hợp đồng
const ContractManagement = lazy(() => import('features/contract/contract-management/pages/ContractManagement'));
const ContractManagementAdd = lazy(() => import('features/contract/contract-management/pages/ContractManagementAdd'));
const ContractManagementGroup = lazy(() =>
    import('features/contract/contract-management/pages/ContractManagementGroup')
);
const ContractManagementPosition = lazy(() =>
    import('features/contract/contract-management/pages/pdf-contract/ContractManagementPosition')
);
const ContractManagementViewEnd = lazy(() =>
    import('features/contract/contract-management/pages/contract-view/ContractManagementViewEnd')
);
const ContractManagementEdit = lazy(() => import('features/contract/contract-management/pages/ContractManagementEdit'));
const ContractManagementView = lazy(() =>
    import('features/contract/contract-management/pages/contract-view/ContractManagementView')
);
const ContractManagementConfirm = lazy(() =>
    import('features/contract/contract-management-confirm/pages/ContractManagementConfirm')
);
const ContractManagementConfirmView = lazy(() =>
    import('features/contract/contract-management-confirm/pages/ContractManagementConfirmView')
);
const ContractManagementConfirmed = lazy(() =>
    import('features/contract/contract-management-confirmed/pages/ContractManagementConfirmed')
);
const ContractManagementConfirmedView = lazy(() =>
    import('features/contract/contract-management-confirmed/pages/ContractManagementConfirmedView')
);
const ContractManagementRefuse = lazy(() =>
    import('features/contract/contract-management-refuse/pages/ContractManagementRefuse')
);
const ContractManagementRefuseView = lazy(() =>
    import('features/contract/contract-management-refuse/pages/ContractManagementRefuseView')
);

const ContractRouter = [
    // * hợp đồng
    {
        path: routerMain.CONTRACT,
        exact: true,
        component: ContractManagement,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}`,
        exact: true,
        component: ContractManagementAdd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractManagementGroup,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractManagementPosition,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractManagementViewEnd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: ContractManagementEdit,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractManagementGroup,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractManagementPosition,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractManagementViewEnd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractManagementView,
    },
    {
        path: routerMain.CONTRACT_CONFIRM,
        exact: true,
        component: ContractManagementConfirm,
    },
    {
        path: `${routerMain.CONTRACT_CONFIRM}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractManagementConfirmView,
    },
    {
        path: routerMain.CONTRACT_CONFIRMED,
        exact: true,
        component: ContractManagementConfirmed,
    },
    {
        path: `${routerMain.CONTRACT_CONFIRMED}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractManagementConfirmedView,
    },
    {
        path: routerMain.CONTRACT_REFUSE,
        exact: true,
        component: ContractManagementRefuse,
    },
    {
        path: `${routerMain.CONTRACT_REFUSE}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractManagementRefuseView,
    },
];
export default ContractRouter;
